import { AutofocusDirective } from '../../../../../../shared/directive/autofocus.directive';
import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  OnInit,
  Output,
} from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { MatSelectModule } from '@angular/material/select';
import { TranslocoModule } from '@jsverse/transloco';
import { FormBaseComponent } from '@anihis/shared/src/shared/base-components/form-base.component';

@Component({
  selector: 'anihis-vetlab-anamnesticki',
  standalone: true,
  imports: [
    AutofocusDirective,
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatCardModule,
    MatSelectModule,
    TranslocoModule,
  ],
  templateUrl: './vetlab-anamnesticki.component.html',
  styleUrls: ['./vetlab-anamnesticki.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VetlabAnamnestickiComponent
  extends FormBaseComponent
  implements OnInit
{
  @Output() formChange = new EventEmitter<any>();
  @Output() save = new EventEmitter<any>();

  constructor() {
    super();
    this.form = this.fb.group({
      vetlabInfo: this.fb.group({
        institution: new FormControl(''),
        clinicalHistory: new FormControl('', [Validators.required]),
        requestedTests: new FormControl('', [Validators.required]),
        livesAt: new FormControl('', []),
        diet: new FormControl('', [Validators.required]),
        product1: new FormControl(''),
        product2: new FormControl(''),
        product3: new FormControl(''),
        freq1: new FormControl(''),
        freq2: new FormControl(''),
        freq3: new FormControl(''),
        appetite: new FormControl('', []),
        thirst: new FormControl('', []),
        otherAnimals: new FormControl('no', []),
        otherAnimalsDetails: new FormControl(''),
        beenAbroad: new FormControl('no', []),
        beenAbroadDetails: new FormControl(''),
        note: new FormControl(''),
        prescribedTherapy: new FormControl(''),
        pruritus: new FormControl(''),
        otherManifestations: new FormControl([]),
        pruritusLocalization: new FormControl(''),
        moreScratching: new FormControl(''),
        steroidEffect: new FormControl(''),
        pruritusObserved: new FormControl(''),
        pinopedalReflex: new FormControl(''),
        skinChangesSeverity: new FormControl(''),
        skinChangesDistribution: new FormControl(''),
        distributionNumber1: new FormControl(''),
        distributionNumber2: new FormControl(''),
        distributionNumber3: new FormControl(''),
        distributionComment1: new FormControl(''),
        distributionComment2: new FormControl(''),
        distributionComment3: new FormControl(''),
        veterinarianName: new FormControl(''),
      }),
    });
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.subs.sink = this.form.valueChanges.subscribe((v) =>
      this.formChange.emit(v),
    );

    // Toggle validation for otherAnimalsDetails when otherAnimals changes
    const otherAnimalsControl = this.form.get(['vetlabInfo', 'otherAnimals']);
    const otherAnimalsDetailsControl = this.form.get([
      'vetlabInfo',
      'otherAnimalsDetails',
    ]);
    if (otherAnimalsControl && otherAnimalsDetailsControl) {
      this.subs.sink = otherAnimalsControl.valueChanges.subscribe((val) => {
        if (val === 'yes') {
          otherAnimalsDetailsControl.setValidators([Validators.required]);
        } else {
          otherAnimalsDetailsControl.clearValidators();
        }
        otherAnimalsDetailsControl.updateValueAndValidity({ emitEvent: false });
      });
      // apply initial state
      if (otherAnimalsControl.value === 'yes') {
        otherAnimalsDetailsControl.setValidators([Validators.required]);
        otherAnimalsDetailsControl.updateValueAndValidity({ emitEvent: false });
      }
    }

    const beenAbroadControl = this.form.get(['vetlabInfo', 'beenAbroad']);
    const beenAbroadDetailsControl = this.form.get([
      'vetlabInfo',
      'beenAbroadDetails',
    ]);
    if (beenAbroadControl && beenAbroadDetailsControl) {
      this.subs.sink = beenAbroadControl.valueChanges.subscribe((val) => {
        if (val === 'yes') {
          beenAbroadDetailsControl.setValidators([Validators.required]);
        } else {
          beenAbroadDetailsControl.clearValidators();
        }
        beenAbroadDetailsControl.updateValueAndValidity({ emitEvent: false });
      });
      if (beenAbroadControl.value === 'yes') {
        beenAbroadDetailsControl.setValidators([Validators.required]);
        beenAbroadDetailsControl.updateValueAndValidity({ emitEvent: false });
      }
    }
  }

  onSubmit() {
    this.form.markAllAsTouched();
    if (this.form.valid) this.save.emit(this.form.value);
  }
}
